import React, { useState, useMemo } from 'react'
import Lottie from 'react-lottie-player'
import { parse } from 'query-string'
import { useLocation } from 'react-router-dom'
import basketAnimation from '../../../assets/json/basketAnimation.json'

const useAutoAddingProduct = () => {
  const location = useLocation()
  const [message, setMessage] = useState(' ')

  const parsedSearch = useMemo(() => parse(location.search), [location.search])
  const autoAddingEnabled = parsedSearch.modifier === 'auto_add'

  const AutoAddingLoader = () => {
    if (!autoAddingEnabled) {
      return null
    }
    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <Lottie loop animationData={basketAnimation} play style={{ width: 150, height: 150 }} />
        <h6>{message}</h6>
      </div>
    )
  }

  return {
    setMessage,
    autoAddingEnabled,
    AutoAddingLoader
  }
}

export { useAutoAddingProduct }
